export default {
    getSeasons() {
        return axios.get('/api/draw/seasons');
    },
    getDivisions(seasonId) {
        return axios.get('/api/draw/seasons/'+seasonId+'/divisions');
    },
    getTeams(divisionId) {
        return axios.get('/api/draw/seasons/divisions/'+divisionId+'/teams');
    },
    getDraw(divisionId) {
        return axios.get('/api/draw/seasons/divisions/'+divisionId+'/draw');
    },
    getResult(divisionId) {
        return axios.get('/api/draw/seasons/divisions/'+divisionId+'/result');
    },
};
